import type { SupportedLanguages } from '@sydle/sydle-one-components';
import type { UserAPI } from '@sydle/ui-api';
import { createTranslator, getAPI } from '@sydle/ui-api';
import { getApp } from '@sydle/ui-utils';
import { reload } from './root.utils';
import navbarStore from '../components/navbar/navbar.store';

export const translation = createTranslator('SD_FRONT_END_MESSAGES');

let lang: string;

export async function setLanguage(language: string): Promise<void> {
  navbarStore.set('loading', true);
  getAPI<UserAPI>('userAPI')?.setCurrentLanguage(language);
  lang = language;
  // reload comonents
  reload();
  // wait reload finish
  document.body.addEventListener('syAppCustomPageDidLoadElements', setContext);
}

export function getLanguage(): string {
  return getAPI<UserAPI>('userAPI')?.getCurrentLanguage() ?? 'en';
}

const setContext = () => {
  navbarStore.set('loading', false);
  // emit event to update language context
  const languageEvent = new CustomEvent('sySDLanguageDidChange', { detail: lang });
  document.body.dispatchEvent(languageEvent);

  document.body.removeEventListener('syAppCustomPageDidLoadElements', setContext);
};

export function getSupportedLanguages(): SupportedLanguages[] {
  const languageOptions: SupportedLanguages[] = getApp()?.languageOptions;
  return languageOptions?.length > 0 ? languageOptions : [{ code: 'en', name: 'English' }];
}
